module.exports = __webpack_public_path__ + "img/0-116.99951ace.jpg";